<template>
  <div class="app-logo" :class="{ 'app-logo--dark': dark }">
    <!-- Icon-Mark: Abgerundetes Quadrat mit Herz -->
    <svg
      width="38"
      height="38"
      viewBox="0 0 38 38"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
    >
      <!-- Hintergrund: abgerundetes Quadrat in brand-bright -->
      <rect width="38" height="38" rx="8" fill="#2790C9" />
      <!-- Herz-Icon (Heroicons solid, 24×24, zentriert bei 7/7) -->
      <path
        transform="translate(7, 7)"
        d="M11.645 20.91l-.007-.003-.022-.012a15.247 15.247 0 01-.383-.218 25.18 25.18 0 01-4.244-3.17C4.688 15.36 2.25 12.174 2.25 8.25 2.25 5.322 4.714 3 7.688 3A5.5 5.5 0 0112 5.052 5.5 5.5 0 0116.313 3c2.973 0 5.437 2.322 5.437 5.25 0 3.925-2.438 7.111-4.739 9.256a25.175 25.175 0 01-4.244 3.17 15.247 15.247 0 01-.383.218l-.022.012-.007.003-.003.001a.752.752 0 01-.704 0l-.003-.001z"
        fill="white"
      />
    </svg>

    <!-- Wortmarke -->
    <div class="app-logo__text">
      <span class="app-logo__name">MEDA</span>
      <span class="app-logo__sub">FORTBILDUNGEN</span>
    </div>
  </div>
</template>

<script>
// dark: weiße Wortmarke für dunklen (Deep-Blue) Header
export default {
  props: { dark: { type: Boolean, default: false } },
};
</script>

<style lang="scss" scoped>
.app-logo {
  display: flex;
  align-items: center;
  gap: 10px;
  text-decoration: none;

  &--dark &__name { color: #fff; }
  &--dark &__sub  { color: $on-deep-muted; }

  &__text {
    display: flex;
    flex-direction: column;
    line-height: 1;
  }

  &__name {
    font-family: 'Poppins', ui-sans-serif, system-ui, sans-serif;
    font-weight: 700;
    font-size: 18px;
    color: $primary;
    letter-spacing: -0.2px;
    line-height: 1;
  }

  &__sub {
    font-family: 'Poppins', ui-sans-serif, system-ui, sans-serif;
    font-weight: 600;
    font-size: 9.5px;
    color: $muted;
    letter-spacing: 0.75px;
    text-transform: uppercase;
    margin-top: 3px;
  }
}
</style>
